import { inWindow, isElectron } from '@/config';
export const sendCrossEvent = async (data, context, options) => {
    if (inWindow() && window.isBridgeWorker) {
        return;
    }
    const { enableRetry = true, asInnermsg = true } = options || {};
    if (isElectron()) {
        context.eventApi.sendSysEvent(data);
        return;
    }
    if (asInnermsg) {
        context.eventApi.sendSysEvent(data);
    }
    try {
        await window.bridgeApi.master.requestData({
            namespace: 'common',
            apiname: 'forwardEvent',
            args: [data],
        });
    }
    catch (ex) {
        if (!enableRetry) {
            console.log('[contact_sync].sendCoreSyncEvent.error', ex);
            return;
        }
        await new Promise(r => setTimeout(r, 1500));
        sendCrossEvent(data, context, {
            enableRetry: false,
            asInnermsg: false,
        });
    }
};
export const forbiddenBridgeOnce = () => {
    inWindow() && window.bridgeApi.master.forbiddenBridgeOnce();
};
